import News from './News';
import NewsAdmin from './NewsAdmin';
import React, { useState, useEffect } from 'react';
import Home from './Home';
import Pricing from './Pricing';
import Login from './LoginFront';
import ForgotPasswordFront from './ForgotPasswordFront';
import CreateNewPasswordFront from './CreateNewPasswordFront';
import SignUpFront from './SignUpFront';
import SaveAsApp from './SaveAsApp';
import StripeContainer from './components/StripeContainer';
import Special from './components/Special';
import Footer from './Footer';
// TokenDebugger removed — dev-only tool should not be in production bundle
import AboutUs from './AboutUs';
import ScrollToTop from './ScrollToTop';
import LegalPage from './LegalPage';
import { LEGAL_DOCS } from './legalDocs';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
function AppMaster() {
  // We force 'home' as the starting point

  const [loggedInUser, setLoggedInUser] = useState(undefined);
  const [resetEmail, setResetEmail] = useState("");

  useEffect(() => {
    const savedUser = localStorage.getItem("loggedInUser");
    const token = localStorage.getItem("token");

    if (savedUser && token) {
      try {
        // Restore state from disk
        setLoggedInUser(JSON.parse(savedUser));
      } catch (e) {
        console.error("Failed to parse user from storage", e);
        localStorage.removeItem("token");
      }
    }
  }, []);

  const commonProps = { loggedInUser, setLoggedInUser };

  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="AppMaster">
        <Routes>
          <Route path="/" element={<Home {...commonProps} />} />
          <Route path="/about-us" element={<AboutUs {...commonProps} />} />
          <Route path="/news" element={<News {...commonProps} />} />
          <Route path="/news-admin" element={<NewsAdmin {...commonProps} />} />
          <Route path="/login" element={<Login {...commonProps} />} />
          <Route path="/pricing" element={<Pricing {...commonProps} />} />
          <Route path="/signup" element={<SignUpFront {...commonProps} />} />
          <Route path="/save-as-app" element={<SaveAsApp {...commonProps} />} />
          <Route path="/payment" element={<StripeContainer {...commonProps} />} />
          <Route path="/special" element={<Special {...commonProps} />} />
          {/* Terms of Use, Privacy Policy, EULA — linked from the Footer */}
          {LEGAL_DOCS.map((doc) => (
            <Route key={doc.path} path={doc.path} element={<LegalPage doc={doc} {...commonProps} />} />
          ))}
          <Route path="/forgot-password" element={<ForgotPasswordFront {...commonProps} setResetEmail={setResetEmail} />} />
          {/*Kicks the user out of /reset-password if they try to access directly without a proper cookie*/}
          <Route
            path="/reset-password"
            element={
              resetEmail ? (
                <CreateNewPasswordFront {...commonProps} resetEmail={resetEmail} />
              ) : (
                <Navigate to="/forgot-password" replace />
              )
            }
          />
          {/* Catch-all redirect */}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
        <Footer {...commonProps} />
      </div>
    </BrowserRouter>
  );
}

export default AppMaster;